/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";

const initState = {};

const SelectedRowsContext = React.createContext(initState);
export const useSelectedRows = () => React.useContext(SelectedRowsContext);

const SelectedRowsSwitchContext = React.createContext(() => {});
export const useSelectedRowsSwitch = () =>
    React.useContext(SelectedRowsSwitchContext);

export default ({ children }) => {
    const [value, setValue] = React.useState(() => initState);
    return (
        <SelectedRowsContext.Provider value={value}>
            <SelectedRowsSwitchContext.Provider
                value={(value) => {
                    if (typeof value === "function") setValue(value);
                    else if (typeof value === "object")
                        setValue((state) => ({ ...state, ...value }));
                }}
            >
                {children}
            </SelectedRowsSwitchContext.Provider>
        </SelectedRowsContext.Provider>
    );
};
